// extracted by mini-css-extract-plugin
export default {"checkboxContainer":"styles_checkboxContainer__6Tsoi"};